


// Ab test wizardx, handled by lambda edge
export const wizardxAbOptions = {
  testName: "wizardx",
  testVarOld: "legacy",
  testVarNew: "legacy-redirect",
  testShareOld: 100,
  testShareNew: 0
}





// WEBPACK FOOTER //
// ./src/constants/ABTestConstants.js